/* 무료보험 프로모션 추가부분 */
import React, { useEffect, useState } from 'react'
import classNames from 'classnames/bind'

import Style from './InsurancePromotionToast.module.scss'

const cx = classNames.bind(Style)

type Props = {
  message: string
}

const InsurancePromotionToast = ({ message }: Props) => {
  const [toastIn, setToastIn] = useState(false)
  const [isShow, setIsShow] = useState(true)

  // [D] 조정 가능한 유지 시간 default=1.5s
  const animationDelay = 1500

  useEffect(() => {
    setToastIn(true)
  }, [])

  useEffect(() => {
    const animationDuration = parseInt(Style.animationDuration)

    const toastOutTimer = setTimeout(() => {
      setToastIn(false)
    }, animationDuration + animationDelay)
    const showTimer = setTimeout(() => {
      setIsShow(false)
    }, animationDuration * 2 + animationDelay)

    return () => {
      clearTimeout(toastOutTimer)
      clearTimeout(showTimer)
    }
  }, [])

  if (!isShow) {
    return null
  }

  return (
    <div className={cx('article')}>
      <div
        className={cx('toast', {
          show: toastIn,
        })}
      >
        <p className={cx('message')}>{message}</p>
      </div>
    </div>
  )
}

export default InsurancePromotionToast
